export const FIXED_ORDER_FIELD_NAMES = {
  EXTERNAL_NUMBER: "Autorización",
  PRICE_LEVEL: "Nivel de precio",
  BILL_TYPE: "Tipo de facturación",
  STATE: "Estado orden",
  ORDER_TYPE: "Tipo de orden",
  DIAG_CODE: "DX PPAL",
  CAMPUS: "Sede",
  CANCEL_VALUE: "Valor pago moderador",
  SERVICE_VALUE: "Valor servicio",
  DESCRIPTION: "Descripción",
  EVENT: "Evento"
};

export const ORDER_CONSTANTS = {
  EDIT_TITLE: "Editar plantilla de órdenes",
  FIELDS_TITLE: "Campos personalizados",
  DEFAULT_FIELDS: "Campos fijos",
  ORDER_TEMP_TEXT: "Plantilla de orden básica",
  PHONE_TYPE: "telefono",
  COLLECTIONS: {
    SESIONES: "sessions"
  },
  BUTTON: {
    ADD_FIELD: "Campo",
    VIEW_ORDER: "Ver Orden"
  },
  LABELS: {
    URL_TEXT: "Imagen de ayuda*",
    HELP_TEXT: "Texto de ayuda*",
    ICON_TEXT: "Icono",
    STATE: `${FIXED_ORDER_FIELD_NAMES.STATE}*`,
    DIAG_CODE: FIXED_ORDER_FIELD_NAMES.DIAG_CODE,
    CANCEL_VALUE: `${FIXED_ORDER_FIELD_NAMES.CANCEL_VALUE}*`,
    SERVICE_VALUE: `${FIXED_ORDER_FIELD_NAMES.SERVICE_VALUE}*`,
    EXTERNAL_NUMBER: `${FIXED_ORDER_FIELD_NAMES.EXTERNAL_NUMBER}*`,
    EVENT: `${FIXED_ORDER_FIELD_NAMES.EVENT}*`,
    BILL_TYPE: FIXED_ORDER_FIELD_NAMES.BILL_TYPE,
    CAMPUS: FIXED_ORDER_FIELD_NAMES.CAMPUS,
    DESCRIPTION: `${FIXED_ORDER_FIELD_NAMES.DESCRIPTION}*`,
    ORDER_TYPE: FIXED_ORDER_FIELD_NAMES.ORDER_TYPE,
    PRICE_LEVEL: `${FIXED_ORDER_FIELD_NAMES.PRICE_LEVEL}*`,
    DASHBOARD_VISIBLE: "Ver en dashboard",
    DASHBOARD_EDITABLE: "Editar en dashboard",
    DATE_CREATED: "Fecha creación",
    DATE_CHANGED: "Fecha Actualización",
    ACTIVATE_DATE: "Fecha Activación",
    AUTHORIZATION_DATE: "Fecha Autorización",
    USER: "Usuario",
    CUSTOM_FIELD: "Campos Personalizados",
    CUPS: "Cups"
  },
  ORDER_TYPE: ["Interna", "Externa"],
  DATA_LIST_NAMES: ["stateList", "billType", "diagnosticPrimaryCode"],
  PREVIEW_EXAMPLE: {
    INTERNAL_NAME: {
      TEXT: "Nombre interno:",
      EXAMPLE: "Ejemplo nombre A"
    },
    EXTERNAL_NAME: {
      TEXT: "Nombre externo:",
      EXAMPLE: "Ejemplo nombre B"
    },
    CUPS: {
      TEXT: "Cups:",
      EXAMPLE: "0000"
    },
    CATEGORY: {
      TEXT: "Categoría:",
      EXAMPLE: "Ejemplo nombre C"
    }
  },
  LIST_FIXED_FIELDS: [
    {
      key: "nroMedicalOrder",
      name: FIXED_ORDER_FIELD_NAMES.EXTERNAL_NUMBER
    },
    { key: "priceLevel", name: FIXED_ORDER_FIELD_NAMES.PRICE_LEVEL },
    { key: "billType", name: FIXED_ORDER_FIELD_NAMES.BILL_TYPE },
    { key: "state", name: FIXED_ORDER_FIELD_NAMES.STATE },
    { key: "orderType", name: FIXED_ORDER_FIELD_NAMES.ORDER_TYPE },
    {
      key: "diagnosticPrimaryCode",
      name: FIXED_ORDER_FIELD_NAMES.DIAG_CODE
    },
    { key: "campus", name: FIXED_ORDER_FIELD_NAMES.CAMPUS },
    { key: "cancelValue", name: FIXED_ORDER_FIELD_NAMES.CANCEL_VALUE },
    { key: "payment", name: FIXED_ORDER_FIELD_NAMES.SERVICE_VALUE }
  ],
  EDITABLE_FIELDS: [
    "state",
    "billType",
    "diagnosticPrimaryCode",
    "cancelValue",
    "nroMedicalOrder"
  ]
};

export const ORDER_STATES = {
  BILLED: "Factura",
  NEW: "Nueva",
  COMPLETED: "Completada",
  CANCELED: "Anulada",
  AUTHORIZED: "Autorizada"
};

export const ORDER_ACCESS = {
  GET: "consultar órdenes",
  POST: "crear órdenes",
  PUT: "modificar órdenes",
  DELETE: "eliminar órdenes"
};
